import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Login from "./pages/Login"; // Importar a página de login
import NotFound from "./pages/NotFound";
import PrivateRoute from "./pages/PrivateRoute";
import Configuracoes from "./pages/Configuracoes";
import ConfiguracoesAdmin from "./pages/ConfiguracoesAdmin";
import ProtectedRouteAdmin from "./pages/ProtectedRouteAdmin";
import { listenForVersionChange } from "./data/listenForVersionChange";
import { useEffect } from "react";
import Bloqueio from "./pages/Bloqueio";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, onValue, ref } from "firebase/database";
import Torneios from "./pages/Torneios";
import TorneioSuper12 from "./pages/TorneioSuper12";
import TorneiosJogos from "./pages/TorneiosJogos";
import TorneioSuper08 from "./pages/TorneioSuper08";
import Regras from "./pages/Regras";
import Estatistica from "./pages/Estatistica";
import Aniversario from "./pages/Aniversario";
import Historico from "./pages/Historico";
import Dashboard from "./pages/Dashboard";

function App() {
  useEffect(() => {
    listenForVersionChange();
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const db = getDatabase();

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const bloqRef = ref(db, `users/${user.uid}/bloq`);

        const unsubscribeDB = onValue(bloqRef, (snapshot) => {
          const isBlocked = snapshot.val() === true;
          if (isBlocked) {
            navigate("/sempermissao");
          }
        });

        // Limpeza da escuta do banco quando deslogar
        return () => unsubscribeDB();
      }
    });

    return () => unsubscribeAuth();
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/sempermissao" element={<Bloqueio />} />
      <Route path="/lista" element={<PrivateRoute element={<Dashboard />} />} />
      <Route
        path="/torneios"
        element={<PrivateRoute element={<Torneios />} />}
      />
      <Route
        path="/historico"
        element={<PrivateRoute element={<Historico />} />}
      />
      <Route
        path="/torneios/super12"
        element={<PrivateRoute element={<TorneioSuper12 />} />}
      />
      <Route
        path="/torneios/super8"
        element={<PrivateRoute element={<TorneioSuper08 />} />}
      />
      <Route
        path="/torneios/jogos"
        element={<PrivateRoute element={<TorneiosJogos />} />}
      />
      <Route
        path="/aniversarios"
        element={<PrivateRoute element={<Aniversario />} />}
      />
      <Route
        path="/viciometro"
        element={<PrivateRoute element={<Estatistica />} />}
      />
      <Route
        path="/configuracoes"
        element={<PrivateRoute element={<Configuracoes />} />}
      />

      <Route
        path="/configuracoesadmin"
        element={<ProtectedRouteAdmin element={<ConfiguracoesAdmin />} />}
      />
      <Route path="/regras" element={<PrivateRoute element={<Regras />} />} />
      <Route path="/" element={<Navigate to="/lista" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
